import { Injectable } from '@angular/core';
import { captureException } from '@sentry/browser';
import { EStorageKeys } from '../enums/storageKeys';
import { IUser } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  private currentUser: IUser | null = null;

  constructor() {
    this.currentUser = JSON.parse(localStorage.getItem(EStorageKeys.CURRENT_USER) || '{}');
  }

  /**
   * Captures frontend-only errors with enhanced context
   * @param error The error object to capture
   * @param component The component name where the error occurred
   * @param action The action that was being performed when the error occurred
   * @param message A descriptive message about the error
   * @param additionalData Optional additional data to include
   * @param level Severity level for Sentry (default: 'error')
   */
  public captureError(
    error: any,
    component: string,
    action: string,
    message: string,
    additionalData?: Record<string, any>,
    level: 'error' | 'warning' | 'info' | 'fatal' = 'error'
  ): void {
    const tags = {
      component,
      action,
      errorType: 'frontend'
    };

    const extra: Record<string, any> = {
      message,
      userId: this.currentUser?._id || null,
      userRole: this.currentUser?.role || null,
      ...this.extractHttpErrorDetails(error),
      ...additionalData
    };

    captureException(error, {
      tags,
      extra,
      level
    });
  }

  private extractHttpErrorDetails(error: any): Record<string, any> {
    if (!error || typeof error !== 'object') {
      return {};
    }
    return {
      status: error.status,
      statusText: error.statusText,
      url: error.url,
      response: error.error,
    };
  }
}
